import { Component } from 'react';
import { Link } from 'react-router-dom';

import { completeName } from 'helpers/name';

class Following extends Component {
  username = () => {
    const { user } = this.props.following;
    let lastname = '';

    // eslint-disable-next-line prefer-destructuring
    if (user.lastname.length > 1) lastname = user.lastname[0];

    return (
      <Link
        to={Routes.user_path(user.id)}
        className="color-black user-picture__name weight--semibold"
      >
        <span>{`${user.firstname} ${lastname}.`}</span>
      </Link>
    );
  };

  render() {
    const {
      following: { user },
    } = this.props;

    return (
      <li>
        <Link
          to={Routes.user_path(user.id)}
          data-toggle="tooltip"
          title={completeName(user)}
        >
          <img alt={completeName(user)} className="big" src={user.photo_url} />
        </Link>
      </li>
    );
  }
}

export default Following;
